export const getUniqueKey = () => {
    const S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}


export const getGbLen = (string = '') => {
    let len = 0
    for (let i = 0; i < string.length; i++) {
        const charCode = string.charCodeAt(i)
        if (charCode > 127 || charCode === 94) {
            len += 2
        } else {
            len++
        }
    }
    return len
}

export const isEmptyObj = (obj = {}) => {
    return !Object.keys(obj).length
}

export const isEmpty = (obj) => {
    if (typeof obj === 'string') {
        obj = obj.trim()
    }

    if (typeof obj === 'object') {
        return isEmptyObj(obj)
    }
    return !obj
}


/**
 * 去除对象中所有符合条件的对象
 * @param {Object} obj 来源对象
 * @param {Function} fn 函数验证每个字段
 */
export const compactObj = (obj, fn = isEmpty) => {
    for (var i in obj) {
        if (typeof obj[i] === 'object') {
            compactObj(obj[i], fn)
        }
        if (!obj[i] || fn(obj[i])) {
            delete obj[i]
        }
    }
    return obj
}

const proxyMap = {
    '1-im.guokr.com': 'guokr_image_1',
    '2-im.guokr.com': 'guokr_image_2',
    '3-im.guokr.com': 'guokr_image_3',
    'qunluo-static.guokr.com': 'qunluo_image',
    'guokrapp-static.guokr.com': 'guokrapp_image',
    'i-fantuan.guokr.net': 'fantuan_image',
    'i-hw-young.guokr.net': 'young_image'
}
export const getImageProxyUrl = (url) => {
    if (!url) return

    for (let baseUrl in proxyMap) {
        if (new RegExp(baseUrl).test(url)) {
            const proxyUrl = url.replace(new RegExp(`https?:\\/\\/${baseUrl}`), `/${proxyMap[baseUrl]}`)
            // 增加.image后缀，让微信识别为stream!!!!!
            if (/\?/.test(proxyUrl)) {
                return proxyUrl.replace('?', '.image?')
            } else {
                return proxyUrl + '.image'
            }
        }
    }

    return url
}
